.supportCardHeader {
	@apply -yst-mt-6 -yst-mx-6 yst-p-6 yst-space-y-4;
}

.supportCardContent {
	@apply yst-mt-0 #{!important};
}

div.supportButtonWrapper {
	@apply yst-flex yst-flex-wrap yst-gap-3 yst-border-b yst-border-slate-200 yst-pb-6;
}

.supportButton {
	@apply yst-flex-1 yst-justify-center yst-gap-2 yst-whitespace-nowrap;
}

.supportButtonIcon {
	@apply yst-w-4 yst-h-4;
}

div.supportTopics {
	@apply yst-pt-6 yst-space-y-4;
}

ul.supportTopicsList {
	@apply yst-space-y-2;
}
